import React from 'react';
import { Button } from '@placer-ui/components';
import { goToSignIn, goToSignUp } from 'router/go-to';
import { useEncodedQuery } from 'hooks/use-query/use-query';

type GoToAuthPageButtonProps = {
    label: string;
    isLoginMode: boolean;
};

export const GoToAuthPageButton = ({ label, isLoginMode }: GoToAuthPageButtonProps) => {
    const nextUrl = useEncodedQuery('next_url') || '';
    const nextUrlObject = {
        nextUrl,
    };

    const goToAuthPage = () =>
        isLoginMode ? goToSignIn(nextUrlObject) : goToSignUp(nextUrlObject);

    return (
        <Button onClick={goToAuthPage} testId="go-to-auth-button" variant="secondary-blue" fullWidth>
            {label}
        </Button>
    );
};
